const ColorCode = {
    YELLOW: "#FFD60A",
    PINK: "#FF375F",
    PURPLE: "#5E5CE6",
    WHITE: "#FFFFFF",
    BLUE: "#576FE7",
    BLUE2: "#9caaf1",
    GRAY: "#A9A9A9",
};
export {ColorCode};
